import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App.vue'
import router from './router'
import { QuillEditor } from '@vueup/vue-quill'
import 'quill/dist/quill.snow.css'

// 创建 Vue 应用实例
const app = createApp(App)

// 全局错误处理器 - 抑制特定的错误
app.config.errorHandler = (err, instance, info) => {
  // 抑制 vue-draggable-plus 和 Sortable 相关的错误
  if (err && typeof err === 'object') {
    const errorMessage = err.message || err.toString()
    
    // 检查是否是 vue-draggable-plus 或 Sortable 相关错误
    if (
      errorMessage.includes('vue-draggable-plus') ||
      errorMessage.includes('Root element not found') ||
      errorMessage.includes('Sortable: `el` must be an HTMLElement') ||
      errorMessage.includes('Sortable: el must be an HTMLElement')
    ) {
      // 在开发环境下输出调试信息，但不抛出错误
      if (import.meta.env.DEV) {
        console.warn('抑制的拖拽相关错误:', {
          error: err,
          message: errorMessage,
          info: info,
          component: instance?.$options?.name || 'Unknown'
        })
      }
      return // 阻止错误继续传播
    }
  }
  
  // 其他错误正常处理
  console.error('Vue 错误:', err, info)
}

// 全局警告处理器
app.config.warnHandler = (msg, instance, trace) => {
  // 抑制特定的警告
  if (msg.includes('vue-draggable-plus') || msg.includes('Sortable')) {
    if (import.meta.env.DEV) {
      console.warn('抑制的拖拽相关警告:', msg)
    }
    return
  }
  
  // 其他警告正常处理
  console.warn('Vue 警告:', msg, trace)
}

// 使用插件
app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.component('QuillEditor', QuillEditor)

// 挂载应用
app.mount('#app')

// 开发环境下的调试信息
if (import.meta.env.DEV) {
  console.log('应用已启动，当前环境：开发环境')
  console.log('Vue 版本：', app.version)
  console.log('路由模式：history')
}

// 浏览器全局错误处理 - 抑制特定的错误
window.addEventListener('error', (event) => {
  const errorMessage = event.message || event.error?.message || ''
  
  // 检查是否是 vue-draggable-plus 或 Sortable 相关错误
  if (
    errorMessage.includes('vue-draggable-plus') ||
    errorMessage.includes('Root element not found') ||
    errorMessage.includes('Sortable: `el` must be an HTMLElement') ||
    errorMessage.includes('Sortable: el must be an HTMLElement')
  ) {
    // 阻止错误继续传播
    event.preventDefault()
    
    // 在开发环境下输出调试信息
    if (import.meta.env.DEV) {
      console.warn('抑制的全局拖拽相关错误:', {
        message: errorMessage,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error
      })
    }
    return false
  }
})

// 浏览器全局未处理的 Promise 错误处理
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || event.reason?.toString() || ''
  
  // 检查是否是 vue-draggable-plus 或 Sortable 相关错误
  if (
    errorMessage.includes('vue-draggable-plus') ||
    errorMessage.includes('Root element not found') ||
    errorMessage.includes('Sortable: `el` must be an HTMLElement') ||
    errorMessage.includes('Sortable: el must be an HTMLElement')
  ) {
    // 阻止错误继续传播
    event.preventDefault()
    
    // 在开发环境下输出调试信息
    if (import.meta.env.DEV) {
      console.warn('抑制的未处理 Promise 拖拽相关错误:', {
        reason: event.reason,
        message: errorMessage
      })
    }
    return false
  }
}) 